/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Cookies from "universal-cookie";
import { ADMIN_API, USER_API } from "../common/common";
import { getImageUrl, getSignupHref, isRealAuthToken, isSignupShowing, Logout, setAuthCookie } from "../common/Funcation";
import {
  getTheme,
  styleObjectGetBG,
  styleObjectGetBGasColor,
  styleObjectGetBorderColor,
  styleObjectGetColor,
} from "../common/StyleSeter";
import { Helmet } from "react-helmet";

import Login from "../pages/Login";
import {
  getApi,
  getApiLink,
  notifyError,
  notifyMessage,
  postApi,
  sendEvent,
} from "../service";
import StakePopup from "./StakePopup";
import BetBox from "../pages/MultiMarket/BetBox";
import transparent from "../assets/images/transparent.gif";
import yelloImage from "../assets/images/s-yellow.svg";
import { isMobile } from "react-device-detect";
import { prefetchLeagueNames } from "../pages/Inplay/leagueCache";

const cookies = new Cookies();

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const HeaderData = useSelector((e: any) => e.Header);
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
  const marketListDetails = useSelector((e: any) => e.marketListDetails);
  const [searchEvent, setSearchEvent] = useState<any>({
    searchText: "",
    typing: false,
    typingTimeout: undefined,
  });
  const [showBetBox, setShowBetBox] = useState(false);
  const [searchData, setSearchData] = useState<any>();
  const balanceData = useSelector((e: any) => e.balance);
  const exposureData = useSelector((e: any) => e.exposure);
  const DD = useSelector((e: any) => e.domainDetails);
  const [domainDetails, setDomainDetails] = useState(DD);
  const [balance, setBalance] = useState(balanceData);
  const [exposures, setExposure] = useState(exposureData);
  const [headerOptions, setHeaderOptions] = useState(HeaderData);
  const [OpenModal, setOpenModal] = useState<boolean>(false);
  const [manageStack, setManageStack] = useState<any>();
  const matchCount = useSelector((e: any) => e.matchCount);
  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
    validationCode: "",
  });
  const [headerOption, setHeaderOption] = useState([
    { name: "Home", hasAccess: true, link: "/", subOption: [] },
    { name: "InPlay ", hasAccess: true, link: "/in-play", subOption: [] },
    {
      name: "Multi Markets",
      hasAccess: true,
      link: "/multimarket",
      subOption: [],
    },
    { name: "Cricket", hasAccess: true, link: "/cricket", subOption: [] },
    { name: "Soccer", hasAccess: true, link: "/soccer", subOption: [] },
    { name: "Tennis", hasAccess: true, link: "/tennis", subOption: [] },
    { name: "Casino", hasAccess: true, link: "", subOption: [] },
  ]);
  const [showPass, setShowPass] = useState(false);
  const currentBets = useSelector((e: any) => e.footerBetList);

  useEffect(() => {
    if (marketListDetails?.data?.length > 0) {
      let HEADER_OPTIONS = [...headerOption];
      HEADER_OPTIONS.forEach((element: any) => {
        marketListDetails.data.forEach((item: any) => {
          if (item?.name === element?.name) {
            element.hasAccess = !item.isBlock;
          }
        });
      });
      setHeaderOption([...HEADER_OPTIONS]);
    }
    return () => { };
  }, [marketListDetails]);

  const [openMenu, setOpenMenu] = useState(false);
  const [isLoadding, setIsLoadding] = useState(true);
  const [isBalanceRefreshing, setIsBalanceRefreshing] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [oneClickActive, setOneClickActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [OpenSetting, setOpenSetting] = useState(false);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [confirmationCode, setConfirmationCode] = useState(
    Math.floor(1000 + Math.random() * 9000)
  );
  const [isValidationWrong, setIsValidationWrong] = useState(false);
  const isCaptcha = process.env.REACT_APP_CAPTCHA;

  const handelInputChange = (e: any) => {
    const { name, value } = e.target;
    setIsValidationWrong(false);
    setFormData({ ...formData, [name]: value });
  };
  const handelSubmit = async (e: any) => {
    e.preventDefault();

    if (
      Validator.current.allValid() &&
      (confirmationCode === parseInt(formData.validationCode) ||
        isCaptcha === "false")
    ) {
      setIsValidationWrong(false);
      // const ipDetails = await getApiLink({
      //   api: "https://ipapi.co/json/?key=wfzfdfQ4cUsaTVURUkj2oF6L51Y4jNE0IM2yE0V2xMyMkxjTsr",
      // });
      // console.log("call ip:  ipDetails :", ipDetails);

      let data = {
        api: USER_API.LOGIN,
        value: {
          user_name: formData.user_name,
          password: formData.password,
          domain: window.location.hostname,
          // city: ipDetails?.data?.city,
          // state: ipDetails?.data?.region,
          // country: ipDetails?.data?.country_name,
          // ISP: ipDetails?.data?.org
        },
      };
      setIsLoadding(true);
      await postApi(data)
        .then(function (loginData) {
          if (loginData) {
            // notifyMessage(loginData.data.message)

            let HeaderData = {
              ...loginData.data.data.roleAccess,
              user_name: loginData.data.data.user_name,
              remaining_balance: loginData.data.data?.balance,
              exposure: loginData.data.data?.exposure,
              ...loginData.data.data,
            };
            dispatch({ type: "HEADER_DETAILS", payload: HeaderData });
            setAuthCookie(loginData.data.data.token);
            dispatch({
              type: "AUTHENTICATION",
              payload: {
                isLogin: true,
                token: loginData.data.data.token,
                changePassword: loginData.data.data.newPassword,
              },
            });
            setOpenModal(false);
            if (loginData.data.data.newPassword) {
              navigate("/change/password");
            }
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        })
        .catch((err) => {
          setIsLoadding(false);
          notifyError(err.response.data.message);
          setIsValidationWrong(false);
          setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
          setFormData({ ...formData, validationCode: "" });
        });
    } else {
      Validator.current.showMessages();
      if (confirmationCode !== parseInt(formData.validationCode)) {
        setIsValidationWrong(true);
      }
      setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
      forceUpdate();
    }
  };
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: this,
    })
  );

  useEffect(() => {
    setBalance(balanceData);

    return () => { };
  }, [balanceData]);
  useEffect(() => {
    setExposure(exposureData);
    return () => { };
  }, [exposureData]);

  useEffect(() => {
    if (balanceData !== "" && exposureData !== "") {
      setIsLoadding(false);
    }
  }, [balanceData, exposureData]);

  useEffect(() => {
    if (cookies.get('skyTokenFront')) {
      setIsLoadding(false);
    }
    setHeaderOptions(HeaderData);
    return () => { };
  }, [HeaderData]);

  useEffect(() => {
    setDomainDetails(DD);
    return () => { };
  }, [DD]);

  useEffect(() => {
    if (HeaderData) {
      setTimeout(() => {
        sendEvent("UPDATE_USER_BALANCE", { userId: HeaderData?._id });
      }, 1000);
    }
    if (matchCount) {
      setInterval(() => {
        sendEvent("GET_LIVE_MATCH_COUNT_FOR_VELKI", {});
      }, 10000);
    }
    return () => { };
  }, []);

  const handleRefreshBalance = async (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isBalanceRefreshing) return;
    setIsBalanceRefreshing(true);

    try {
      const data = {
        api: USER_API.GET_PROFILE,
        value: {},
      };
      const response = await getApi(data);
      if (response?.data?.data) {
        dispatch({ type: "HEADER_DETAILS", payload: response.data.data });
        if (response.data.data.balance !== undefined) {
          setBalance(response.data.data.balance);
        }
        if (response.data.data.exposure !== undefined) {
          setExposure(response.data.data.exposure);
        }
      }
    } catch (err: any) {
      console.error("Failed to refresh balance:", err);
      if (err?.response?.data?.statusCode === 401) {
        Logout();
        navigate("/login");
      }
    } finally {
      // Also notify socket to synchronize balance if connected
      if (HeaderData?._id) {
        sendEvent("UPDATE_USER_BALANCE", { userId: HeaderData._id });
      }
      setTimeout(() => {
        setIsBalanceRefreshing(false);
      }, 700);
    }
  };

  const HandleNavigation = (path: string) => {
    navigate(path);
  };

  const HandleLogOut = (e: any) => {
    e.preventDefault();
    Logout(e);
    dispatch({
      type: "AUTHENTICATION",
      payload: { isLogin: false, token: "", changePassword: false },
    });
    navigate("/login");
  };

  const items = [
    { id: 0, name: "Cobol" },
    { id: 1, name: "JavaScript" },
    { id: 2, name: "Basic" },
    { id: 3, name: "PHP" },
    { id: 4, name: "Java" },
  ];

  const getInPlayData = async (FILTER: string) => {
    // setIsLoading(true)

    let data = {
      api: USER_API.IN_PLAY,
      value: { filter: FILTER },
    };

    await postApi(data)
      .then(function (response) {
        if (FILTER === "play") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_IN_PLAY",
            payload: response.data.data,
          });
        } else if (FILTER === "today") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TODAY",
            payload: response.data.data,
          });
        } else if (FILTER === "tomorrow") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TOMORROW",
            payload: response.data.data,
          });
        } else {
          dispatch({ type: "SET_IN_PLAY_DETAILS", payload: undefined });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      sendEvent("GET_SPORTS", { type: "cricket" });
      sendEvent("GET_SPORTS", { type: "tennis" });
      sendEvent("GET_SPORTS", { type: "soccer" });
    }, 5000);
    prefetchLeagueNames();
    getInPlayData("play");
    getInPlayData("today");
    getInPlayData("tomorrow");
  }, []);

  const [currentBetCount, setCurrentBetCount] = useState();
  useEffect(() => {
    if (isRealAuthToken(cookies.get("skyTokenFront"))) {
      // setInterval(() => {
      getBetCount();
      // }, 2000);
    }
  }, []);

  const getBetCount = async () => {
    let data = {
      api: USER_API.BET_LIST,
      value: {},
    };
    await postApi(data)
      .then(function (response) {
        setCurrentBetCount(response.data.data.length);
      })
      .catch((err) => {
        if (err.response.data.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };

  const signupHref = getSignupHref(domainDetails);

  return (
    <>
      {window.innerWidth < 993 && showBetBox && (
        <div>
          {" "}
          <BetBox isMobile={true} betHistoryShow={showBetBox} />{" "}
        </div>
      )}

      <header className="header">
        <Helmet>
          <title>{domainDetails?.title}</title>
        </Helmet>
        <div className="header_wrp" style={styleObjectGetBG(domainDetails?.colorSchema)}>
          <div className="header_wrp_l">
            {window.location.pathname.split("/")[1] === "multimarket" ? (
              <span className="menu-btn" onClick={() => navigate("sports")} style={{ marginRight: "9px", marginLeft: "0px" }}>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  className="fs-4"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M17.77 3.77L16 2 6 12l10 10 1.77-1.77L9.54 12z"></path>
                </svg>
                {/* <img src="/images/menu.webp" style={{ width: "20px", height: "20px" }} /> */}
              </span>
            ) : (
              cookies.get("skyTokenFront") && (
                <span
                  className="menu-btn"
                  onClick={() => setOpenMenu(!openMenu)} style={{ marginRight: "9px", marginLeft: "0px" }}
                >
                  {/* <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" className="fs-4" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"></path></svg> */}
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4 6H20M4 12H20M4 18H20"
                      stroke="#000000"
                      strokeWidth="2.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg> */}
                  <img src="/images/menu.webp" style={{ width: "21px", height: "21px" }} />
                </span>
              )
            )}

            <div className="header_wrp_l_logo c">
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  if (window.location.pathname !== "/") navigate("/");
                }}
              >
                <img src={getImageUrl(domainDetails?.logo)} alt="logo" />
              </a>
            </div>
          </div>

          <div className="header_wrp_r">
            {!isAuthenticated && !cookies.get("skyTokenFront") ? (
              <>
                <ul className="login-wrap d_flex mobile_login ">
                  {isSignupShowing(domainDetails) && (
                    <li>
                      <a
                        className="btn-signup-new"
                        href={signupHref || undefined}
                        target={signupHref ? "_blank" : undefined}
                        rel={signupHref ? "noopener noreferrer" : undefined}
                        style={{ fontSize: "13.52px", height: "27.04px" }}
                        onClick={(event) => {
                          if (!signupHref) event.preventDefault();
                        }}
                      >
                        <span className="header-action-icon header-action-icon--signup" />
                        SignUp
                      </a>
                    </li>
                  )}
                  <li>
                    <Link id="loginBtn" to="/login" className="btn-login" style={{ fontSize: "13.52px", height: "27.04px" }}>
                      <span className="header-action-icon header-action-icon--login" />
                      Login
                    </Link>
                  </li>
                </ul>
              </>
            ) : (
              <ul className="account-wrap">
                <li className="main-wallet" style={{ marginRight: "5px" }}>
                  <a id="multiWallet" className="a-wallet">
                    <ul id="accountCredit d_flex" style={{ fontSize: "11.41px" }}>
                      {!isLoadding ? (
                        isBalanceRefreshing ? (
                          <li
                            className="d-flex align-items-center justify-content-center"
                            style={{ minHeight: "30px", minWidth: "100px" }}
                          >
                            <div className="nine-dots-loader">
                              {[...Array(8)].map((_, i) => (
                                <span
                                  key={i}
                                  className="dot"
                                  style={{
                                    backgroundColor:
                                      getTheme(domainDetails?.colorSchema)?.color ||
                                      getTheme(domainDetails?.colorSchema)?.backgroundColor ||
                                      "#ffffff",
                                    animationDelay: `${i * 0.1}s`,
                                  }}
                                />
                              ))}
                            </div>
                          </li>
                        ) : (
                          <>
                            <li style={domainDetails?.colorSchema ? { color: getTheme(domainDetails?.colorSchema)?.color } : { color: "#ffffff" }}>
                              <span style={{ opacity: 1 }}>@{HeaderData.user_name}</span>
                            </li>
                            <li
                              style={styleObjectGetBGasColor(
                                domainDetails?.colorSchema
                              )}
                            >
                              <span style={domainDetails?.colorSchema ? { color: getTheme(domainDetails?.colorSchema)?.color, fontWeight: 700 } : { color: "#ffffff", fontWeight: 700 }}>
                                {domainDetails?.currency
                                  ? domainDetails?.currency
                                  : "PTH"}{" "}
                              </span>
                              <span
                                style={domainDetails?.colorSchema ? { color: getTheme(domainDetails?.colorSchema)?.color } : { color: "#ffffff" }}
                                id="betCredit"
                              >
                                {balance}
                              </span>
                              <span style={domainDetails?.colorSchema ? { color: getTheme(domainDetails?.colorSchema)?.color, paddingLeft: "7px", fontWeight: 700, opacity: 0.7 } : { color: "#ffffff", paddingLeft: "7px", fontWeight: 700, opacity: 0.7 }}> Exp </span>
                              <span
                                style={{ color: "red", background: "transparent" }}
                                id="totalExposure"
                              >
                                ({exposures == 0 ? 0 : exposures})
                              </span>
                            </li>
                          </>
                        )
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="100px"
                          height="40px"
                          viewBox="0 0 100 100"
                          preserveAspectRatio="xMidYMid"
                        >
                          <g transform="translate(20 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="-0.375s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                          <g transform="translate(40 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="-0.25s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                          <g transform="translate(60 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="-0.125s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                          <g transform="translate(80 50)">
                            <circle
                              cx="0"
                              cy="0"
                              r="6"
                              fill={
                                getTheme(domainDetails?.colorSchema)
                                  ?.backgroundColor
                              }
                            >
                              <animateTransform
                                attributeName="transform"
                                type="scale"
                                begin="0s"
                                calcMode="spline"
                                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                values="0;1;0"
                                keyTimes="0;0.5;1"
                                dur="1s"
                                repeatCount="indefinite"
                              ></animateTransform>
                            </circle>
                          </g>
                        </svg>
                      )}
                    </ul>
                    <div
                      className={`balance-refresh-spinner ${isBalanceRefreshing ? "spinning" : ""}`}
                      onClick={handleRefreshBalance}
                      title="Refresh Balance"
                    >
                      <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        height="20"
                        width="20"
                        style={{ transform: "rotate(45deg)" }}
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeWidth={"2.2px"}
                          strokeLinejoin="round"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </li>
              </ul>
            )}
          </div>
        </div>


        <div className={`sidebar-container ${openMenu ? "is-open" : ""}`}>
          <div className={`sidebar-wrapper ${openMenu ? "sidebar-open" : ""}`}>
            <div className="top-sidebar mb-3 ps-1 d-flex justify-content-between">
              <strong style={{ fontSize: "15.6px" }}>Menu</strong>
              <button
                className="bg-transparent border-0 p-0"
                onClick={() => setOpenMenu(!openMenu)}
              >
                <svg
                  stroke="currentColor"
                  fill="none"
                  strokeWidth="0"
                  viewBox="0 0 15 15"
                  height="20px"
                  width="20px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
            </div>
            <ul className="p-0 m-0 mb-3">
              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/my-profile')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 448 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"></path>
                  </svg>{" "}
                  <span>My Profile</span>
                </a>
              </li>
              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/balance-overview')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 512 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"></path>
                  </svg>
                  <span>Balance Overview</span>
                </a>
              </li>

              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/current-bets')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h15v3h-6c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h6.001v3H5zm15-9v4h-6v-4h6z"></path>
                  </svg>{" "}
                  <span>Current Bets</span>{" "}
                  {
                    isAuthenticated && currentBets && currentBets.length > 0 ? <strong style={{ fontSize: "15.6px !important" }} className="rounded-count ms-2 bg-yellow d-block rounded text-white" >
                      {currentBets.length}
                    </strong> : ""
                  }

                </a>
              </li>
              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/account-statement')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                    <path d="M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"></path>
                  </svg>{" "}
                  <span>Account Statement</span>
                </a>
              </li>
              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/bets-history')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 512 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                  </svg>{" "}
                  <span>Bets History</span>
                </a>
              </li>
              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/profit-and-loss')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"></path>
                  </svg>{" "}
                  <span>Profit &amp; Loss</span>
                </a>
              </li>
              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/active-log')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13 12.8293C14.1652 12.4175 15 11.3062 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.3062 9.83481 12.4175 11 12.8293V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12.8293ZM11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10Z"
                      fill="currentColor"
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
                      fill="currentColor"
                    ></path>
                  </svg>{" "}
                  <span>Active Log</span>
                </a>
              </li>

            </ul>
            {/* <ul className="p-0 m-0 mb-3">
                <li>
                  <a className="text-decoration-none" href="/p2p-transfer">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m15 12 5-4-5-4v2.999H2v2h13zm7 3H9v-3l-5 4 5 4v-3h13z"></path>
                    </svg>{" "}
                    <span>P2P Transfer</span>
                  </a>
                </li>
                <li>
                  <a className="text-decoration-none" href="/p2p-transfer-log">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M4 18v3h16v-14l-8 -4l-8 4v3"></path>
                      <path d="M4 14h9"></path>
                      <path d="M10 11l3 3l-3 3"></path>
                    </svg>{" "}
                    <span>P2P Transfer log</span>
                  </a>
                </li>
              </ul> */}
            <ul className="p-0 m-0 mb-3">
              <li>
                <a className="text-decoration-none" onClick={() => {
                  navigate('/setting')
                  setOpenMenu(false)
                }}>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 512 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M413.967 276.8c1.06-6.235 1.06-13.518 1.06-20.8s-1.06-13.518-1.06-20.8l44.667-34.318c4.26-3.118 5.319-8.317 2.13-13.518L418.215 115.6c-2.129-4.164-8.507-6.235-12.767-4.164l-53.186 20.801c-10.638-8.318-23.394-15.601-36.16-20.801l-7.448-55.117c-1.06-4.154-5.319-8.318-10.638-8.318h-85.098c-5.318 0-9.577 4.164-10.637 8.318l-8.508 55.117c-12.767 5.2-24.464 12.482-36.171 20.801l-53.186-20.801c-5.319-2.071-10.638 0-12.767 4.164L49.1 187.365c-2.119 4.153-1.061 10.399 2.129 13.518L96.97 235.2c0 7.282-1.06 13.518-1.06 20.8s1.06 13.518 1.06 20.8l-44.668 34.318c-4.26 3.118-5.318 8.317-2.13 13.518L92.721 396.4c2.13 4.164 8.508 6.235 12.767 4.164l53.187-20.801c10.637 8.318 23.394 15.601 36.16 20.801l8.508 55.117c1.069 5.2 5.318 8.318 10.637 8.318h85.098c5.319 0 9.578-4.164 10.638-8.318l8.518-55.117c12.757-5.2 24.464-12.482 36.16-20.801l53.187 20.801c5.318 2.071 10.637 0 12.767-4.164l42.549-71.765c2.129-4.153 1.06-10.399-2.13-13.518l-46.8-34.317zm-158.499 52c-41.489 0-74.46-32.235-74.46-72.8s32.971-72.8 74.46-72.8 74.461 32.235 74.461 72.8-32.972 72.8-74.461 72.8z"></path>
                  </svg>
                  <span>Setting</span>
                </a>
              </li>
            </ul>
            <button
              className="logout-button"
              onClick={(e) => HandleLogOut(e)}
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 24 24"
                className="me-2"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m2 12 5 4v-3h9v-2H7V8z"></path>
                <path d="M13.001 2.999a8.938 8.938 0 0 0-6.364 2.637L8.051 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051 2.051 3.08 2.051 4.95-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637c1.7-1.699 2.637-3.959 2.637-6.364s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"></path>
              </svg>
              Logout
            </button>
            <div className="time-zone text-center pt-4">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 1024 1024"
                className="me-2 fs-4"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"></path>
              </svg>
              <span>Time Zone：GMT+6:00</span>
            </div>
          </div>
          <div
            className={`overlay ${openMenu ? "overlay-enter" : "overlay-exit"}`}
            onClick={() => setOpenMenu(false)}
          ></div>
        </div>


        {/* <div className="menu_part" style={styleObjectGetBG(domainDetails?.colorSchema)}>
                    <ul>
                        {headerOption.map((item, i) => {
                            if (!item.hasAccess) return false
                            if (item.name === "Casino" && !cookies.get('skyTokenFront')) return false
                            return (
                                <li key={i} >
                                    {["Cricket", "Soccer", "Tennis"].includes(item.name) ? <Link style={styleObjectGetColor(domainDetails?.colorSchema)} className={`${item.subOption.length > 0 ? "menu-drop" : ''} ${(window.location.pathname === item.link) ? 'selected' : ''}`} to={item.link}>
                                        {item.name}
                                        {item.name === "Cricket" && matchCount && <span id="tagLive" className="tag-live"><strong></strong>{matchCount.cricket}</span>}
                                        {item.name === "Soccer" && matchCount && <span id="tagLive" className="tag-live"><strong></strong>{matchCount.soccer}</span>}
                                        {item.name === "Tennis" && matchCount && <span id="tagLive" className="tag-live"><strong></strong>{matchCount.tennis}</span>}
                                        {item.name === "E-Soccer" && <span id="tagLive" className="tag-live"><strong></strong>5</span>}
                                        {item.name === "Kabaddi" && <span id="tagLive" className="tag-live"><strong></strong>0</span>}
                                    </Link> : item.name === "Casino" && cookies.get('skyTokenFront') ? <a style={styleObjectGetColor(domainDetails?.colorSchema)} className={`${item.subOption.length > 0 ? "menu-drop" : ''} ${(window.location.pathname === item.link) ? 'selected' : ''} ${item.name === "Casino" ? "casino_class" : ''}`}
                                        onClick={() => getCasinoLink()}>
                                        {item.name}
                                        {item.name === "Casino" ? <img style={{ width: "20px" }} src="/images/card-game.svg" /> : ''}
                                    </a> : <a style={styleObjectGetColor(domainDetails?.colorSchema)} className={`${item.subOption.length > 0 ? "menu-drop" : ''} ${(window.location.pathname === item.link) ? 'selected' : ''}`}
                                        href={item.link}>
                                        {item.name}
                                    </a>}
                                </li>)

                        })}

                    </ul>

                    <ul className='setting-wrap'>
                        <li className="time_zone"><span>Time Zone :</span> GMT+5:30</li>
                        <li >
                            <a id="oneClickSetting" className={`one_click ${oneClickActive ? 'active' : ''}`} style={styleObjectGetBGasColor(domainDetails?.colorSchema, true)}> <input type="checkbox" name="" id="" style={{ margin: 0 }} /> One Click Bet </a>
                        </li>
                        <li><a id="slipSet" className="setting" onClick={() => handleSetting()}>Setting <img src="/images/setting.svg" /></a></li>
                    </ul>

                </div> */}

        {/* <div className="mobilemenu">
                    <nav>
                        <ul>
                            <li id="mini" className="game-nav">
                                <a onClick={() => getCasinoLink(true)} className="ui-link">
                                    <img className="icon-promote" src="/images/promot.gif" alt="mini" />
                                </a>
                            </li>
                            <li className={['/cricket', '/soccer', '/tennis'].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <Link className="" to="/cricket">
                                    <img className="icon-sports" src="/images/Sports.svg" alt="Sports" />
                                    Sports
                                </Link>
                            </li>
                            <li className={['/in-play'].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <Link className="" to="/in-play">
                                    <img className="icon-inplay" src="/images/menu-In-Plan.svg" alt="In-Play" />
                                    In-Play
                                </Link>
                            </li>
                            <li className={window.location.pathname === '/' || window.location.pathname === '/#' ? "main-nav select" : ''}>
                                <a className="" href="/">
                                    <img className="icon-home" src="/images/Home.svg" alt="Home" />
                                    Home
                                </a>
                            </li>
                            <li className={['/multimarket',].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <a className="multi_market" href="/multimarket">
                                    <img className="icon-pin" src="/images/Multi-Markets.svg" alt="Multi Markets" />
                                    Multi Markets
                                </a>
                            </li>
                            <li className={['/myAccount', '/user'].includes(window.location.pathname) ? "main-nav select" : ''}>
                                <a href="/myAccount" data-bs-toggle="modal" data-bs-target="#myLoginModalFront">
                                    <img className="icon-account" src="/images/Account.svg" alt="Account" />
                                    Account
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div> */}
      </header>

      {OpenModal && (
        <div
          className={`login popup-wrp fade ${OpenModal ? "popup-show " : ""}`}
        >
          <div className="pop">
            <div className="pop-content">
              <div className="pop-head">
                <div
                  className="pop-close"
                  onClick={() => setOpenModal(true)}
                ></div>
              </div>
              <div className="pop-body">
                <Login OpenModal={OpenModal} setOpenModal={setOpenModal} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
